import { useSelector } from 'react-redux'
import { useAlertPopupsContext } from 'context/AlertPopups'
import { PROJECT_MAX_DURATION } from 'consts'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { translate } from 'utils/translations'
import { transformTextVariables } from 'utils/text-transformation'
import { T } from 'consts/translationKeys'
import { useCallback } from 'react'

const PROJECT_MAX_DURATION_IN_MINUTES = (PROJECT_MAX_DURATION / 60).toString()

// TODO: Refactor this hook since it modifies the context state on each check, even if it's not expected!
const useDurationLimitCheck = () => {
  const projectDuration = useSelector(projectDataSelectors.duration)
  const { setAlertPopupsData } = useAlertPopupsContext()

  const isDurationAllowed = useCallback(
    (newDuration: number) => {
      const isWithinLimit =
        projectDuration + newDuration <= PROJECT_MAX_DURATION

      if (isWithinLimit) return true

      setAlertPopupsData({
        warningPopup: {
          title: transformTextVariables(
            translate(T.PROJECT_DURATION_WARNING_MESSAGE),
            [{ value: PROJECT_MAX_DURATION_IN_MINUTES }]
          ),
          description: transformTextVariables(
            translate(T.PROJECT_BETA_VERSION_DURATION_WARNING_MESSAGE),
            [{ value: PROJECT_MAX_DURATION_IN_MINUTES }]
          ),
          buttons: {
            confirm: { label: translate(T.OK_THANKS_LABEL) }
          }
        }
      })

      return false
    },
    [projectDuration, setAlertPopupsData]
  )

  return { isDurationAllowed }
}

export default useDurationLimitCheck
